var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-action-navbar',{attrs:{"columns":_vm.items}},[_c('template',{slot:"12"},[_vm._v("Example")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }